/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientData } from '../../models/client-data';

export interface ClientManagementGetAllClientDynamoDbGet$Plain$Params {
}

export function clientManagementGetAllClientDynamoDbGet$Plain(http: HttpClient, rootUrl: string, params?: ClientManagementGetAllClientDynamoDbGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientData>>> {
  const rb = new RequestBuilder(rootUrl, clientManagementGetAllClientDynamoDbGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ClientData>>;
    })
  );
}

clientManagementGetAllClientDynamoDbGet$Plain.PATH = '/ClientManagement/GetAllClientDynamoDB';
